import React from 'react'
import {
  Typography,
  FormControlLabel,
  RadioGroup,
  withStyles,
} from '@material-ui/core'
import styles from '../styles'
import Radio from '@material-ui/core/Radio'
const StyledRadio = withStyles({
  root: {
    //color: green[400],
    '&$checked': {
      color: '#015FFB',
    },
  },
  checked: {},
})(props => <Radio color="default" {...props} />)

const providers = [
  {
    value: 0,
    label: 'SendGrid',
  },
  {
    value: 1,
    label: 'MailChimp',
  },
  {
    value: 2,
    label: 'MailerSend',
  },
  {
    value: 3,
    label: 'SMTP',
  },
]

const EmailProviderSelector = ({
  classes,
  selectedProvider,
  onProviderChange,
}) => {
  return (
    <div className={classes.providerSelector}>
      <Typography>Choose your email provider</Typography>
      <RadioGroup
        value={selectedProvider}
        onChange={onProviderChange}
        className={classes.radioGroup}
      >
        {providers.map(provider => (
          <FormControlLabel
            key={provider.value}
            value={provider.value}
            control={<StyledRadio />}
            label={provider.label}
          />
        ))}
      </RadioGroup>
    </div>
  )
}

export default withStyles(styles)(EmailProviderSelector)
